var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNutritionAware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_9",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_9",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231300;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.25,10.32a7.17,7.17,0,0,0-2.76.56,9.35,9.35,0,0,1-1.68.6,15,15,0,0,0-.59-2.38,8.6,8.6,0,0,0,2.33.35,4.9,4.9,0,0,0,2.64-.7c2.4-1.51,2.56-5.09,2.57-5.49A1.26,1.26,0,0,0,25,2.08C24.65,1.92,21.35.53,19,2A5.93,5.93,0,0,0,16.6,5.92,6.67,6.67,0,0,0,15,4.35a1.25,1.25,0,0,0-1.35,2.1c.09.06,1.89,1.33,2.59,5a4.75,4.75,0,0,1-.76-.34,7.19,7.19,0,0,0-3.24-.77C7.69,10.32,4,14.71,4,20.11c0,5.17,4,12.67,10.33,12.67a7.72,7.72,0,0,0,2.63-.46,2.75,2.75,0,0,1,1.63,0,.94.94,0,0,0,.15.06,7.56,7.56,0,0,0,2.53.43c6.31,0,10.34-7.5,10.34-12.67C31.57,14.71,27.84,10.32,23.25,10.32Zm-3-6.16a3.93,3.93,0,0,1,2.87-.08,3.92,3.92,0,0,1-1.3,2.56A3.93,3.93,0,0,1,19,6.71,3.92,3.92,0,0,1,20.29,4.16ZM12.74,17.7c-.71,0-1.32.85-1.32,1.85a1.25,1.25,0,0,1-2.5,0,4.11,4.11,0,0,1,3.82-4.35,1.25,1.25,0,0,1,0,2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNutritionAware);
export default __webpack_public_path__ + "static/media/nutrition-aware.8b17e493a5dee6bbae5a8bafef956533.svg";
export { ForwardRef as ReactComponent };